import { render, staticRenderFns } from "./allblack.vue?vue&type=template&id=6be2aef4&"
import script from "./allblack.vue?vue&type=script&lang=js&"
export * from "./allblack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports